<div class="tw-block tw-border-spacing-0 tw-w-full tw-flex-1 tw-h-screen tw-overflow-hidden tw-font-body">
  <div class="tw-flex tw-flex-col tw-flex-1 tw-h-full tw-min-h-0">
    <div class="tw-w-full tw-flex-initial">
      <div class="tw-bg-gray-50 tw-h-14 tw-px-6 tw-flex tw-items-center tw-w-full tw-justify-center tw-z-[100] tw-relative">
        <div class="tw-absolute tw-right-6 tw-top-1/2 -tw-translate-y-1/2" (click)="navigateBack()">
          <span class="tw-text-black tw-inline-block tw-mx-1">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" class="tw-w-5 tw-h-5">
              <path d="M6 6 L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <path d="M18 6 L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </span>
        </div>
        <span class="tw-font-body tw-font-bold tw-text-300">Refund Policy - Hair & Skin</span>
      </div>
    </div>
    <div class="tw-w-full tw-flex-auto tw-overflow-y-auto tw-overflow-x-hidden tw-min-h-0" [class.ios-momentum-scroll]="isIosDevice">
      <div class="tw-w-full tw-flex tw-flex-col">
        @for (image of images; track image) {
          <img class="tw-w-full" src="{{ image }}" alt="{{ image }}" />
        }
      </div>
    </div>
  </div>
</div>

